import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { NotificationContext } from "../../context/NotificationContext";
import { NAV_ITEMS, ADMIN_NAV_ITEMS } from "./navItems";
import NavBadge from "./NavBadge";
import logo from "../../Assets/Images/EMPACT LOGO.png";

function NavItem({ to, label, icon: Icon, notifKey, categoryCounts }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
          isActive
            ? "bg-primary-50 text-primary-700"
            : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
        }`
      }
    >
      <Icon className="h-[18px] w-[18px]" />
      {label}
      {notifKey && <NavBadge count={categoryCounts[notifKey]} />}
    </NavLink>
  );
}

export default function Sidebar() {
  const { isAdmin } = useContext(AuthContext);
  const { categoryCounts } = useContext(NotificationContext);

  return (
    <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 flex-col border-r border-slate-200 bg-white lg:flex">
      <div className="flex h-16 items-center gap-2 px-6">
        <img src={logo} alt="Empact Alumni" className="h-8 w-auto" />
        <span className="text-[15px] font-bold text-slate-900">Empact Alumni</span>
      </div>

      <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-4">
        {NAV_ITEMS.map((item) => (
          <NavItem key={item.to} {...item} categoryCounts={categoryCounts} />
        ))}

        {isAdmin && (
          <>
            {/* A clear visual boundary — admin-only navigation is never
                mixed in with everyone's nav items, so it's obvious at a
                glance which links only an admin can see. */}
            <div className="my-3 border-t border-slate-100 pt-3">
              <p className="px-3 pb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                Admin
              </p>
            </div>
            {ADMIN_NAV_ITEMS.map((item) => (
              <NavItem key={item.to} {...item} categoryCounts={categoryCounts} />
            ))}
          </>
        )}
      </nav>

      <div className="border-t border-slate-100 px-6 py-4">
        <p className="text-xs text-slate-400">Empact Alumni &copy; {new Date().getFullYear()}</p>
      </div>
    </aside>
  );
}
